<template>
  <el-row style="padding: 8px; border-bottom: solid 1px #E6E6E6;background: #ffffff; font-weight: 900; color:#000000;font-size:16px; margin-top:18px; box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 6px;">
    <el-col :span="17" style="text-align: left;">應付金額</el-col>
    <el-col :span="7" style="text-align: right;">${{ formatNumber(payableAmount) }}</el-col>
  </el-row>
</template>

<script>
export default {
  name: 'CalculatedPayableAmountRow',
  props: {
    payableAmount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatNumber(num) {
      const value = Number(num) || 0
      return value.toLocaleString()
    },
  },
}
</script>
